import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "d-flex align-center justify-center fill-height" }
const _hoisted_2 = { class: "text-h6 text-medium-emphasis" }
const _hoisted_3 = { class: "text-body-2 text-medium-emphasis" }

import { computed } from 'vue';
import { useDisplay } from 'vuetify';
import { useAccountStore } from '@/stores/account';


export default /*@__PURE__*/_defineComponent({
  __name: 'ResourceUnsupported',
  props: {
    model: {}
  },
  emits: ["closeDialog"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit;

const { width } = useDisplay();
const accountStore = useAccountStore();

const isSmallScreen = computed(() => width.value < 768);
const isAdmin = computed(() => accountStore.account?.userType === 'ADMIN');
const isResourcePublished = computed(() => !props.model || props.model.status === 'PUBLISHED');

const closeDialog = () => emit('closeDialog');

const download = () => window.open(props.model.path, '_self');

return (_ctx: any,_cache: any) => {
  const _component_v_toolbar_title = _resolveComponent("v-toolbar-title")!
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_toolbar = _resolveComponent("v-toolbar")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_card = _resolveComponent("v-card")!
  const _directive_tooltip = _resolveDirective("tooltip")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_v_card, { "min-width": "400" }, {
      default: _withCtx(() => [
        _createVNode(_component_v_toolbar, {
          color: "primary",
          "max-height": "64"
        }, {
          default: _withCtx(() => [
            (__props.model && !isSmallScreen.value)
              ? (_openBlock(), _createBlock(_component_v_toolbar_title, {
                  key: 0,
                  class: "mx-5 altfont"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(__props.model.name), 1 /* TEXT */)
                  ]),
                  _: 1 /* STABLE */
                }))
              : _createCommentVNode("v-if", true),
            _createVNode(_component_v_spacer),
            (isAdmin.value && !isResourcePublished.value)
              ? _withDirectives((_openBlock(), _createBlock(_component_v_btn, {
                  key: 1,
                  icon: "",
                  variant: "plain",
                  color: "warning",
                  class: "d-print-none"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_icon, null, {
                      default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
                        _createTextVNode("mdi-alert-outline", -1 /* CACHED */)
                      ]))]),
                      _: 1 /* STABLE */
                    })
                  ]),
                  _: 1 /* STABLE */
                })), [
                  [
                    _directive_tooltip,
                    _ctx.$t('cortona.ipc.resource-not-published', { status: props.model && props.model.status }),
                    void 0,
                    { "bottom-center": true }
                  ]
                ])
              : _createCommentVNode("v-if", true),
            _createVNode(_component_v_btn, {
              icon: "",
              onClick: closeDialog
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_icon, null, {
                  default: _withCtx(() => [...(_cache[1] || (_cache[1] = [
                    _createTextVNode("mdi-close", -1 /* CACHED */)
                  ]))]),
                  _: 1 /* STABLE */
                })
              ]),
              _: 1 /* STABLE */
            })
          ]),
          _: 1 /* STABLE */
        }),
        _createVNode(_component_v_card_text, { class: "d-flex flex-column align-center justify-center py-10 ga-4" }, {
          default: _withCtx(() => [
            _createVNode(_component_v_icon, {
              size: "64",
              color: "grey-lighten-1"
            }, {
              default: _withCtx(() => [...(_cache[2] || (_cache[2] = [
                _createTextVNode("mdi-file-alert-outline", -1 /* CACHED */)
              ]))]),
              _: 1 /* STABLE */
            }),
            _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.$t('resource-preview.unsupported.title')), 1 /* TEXT */),
            _createElementVNode("div", _hoisted_3, _toDisplayString(__props.model.mimeType), 1 /* TEXT */),
            (__props.model.path)
              ? (_openBlock(), _createBlock(_component_v_btn, {
                  key: 0,
                  color: "primary",
                  variant: "tonal",
                  "prepend-icon": "mdi-download-box-outline",
                  class: "mt-2",
                  onClick: download
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t('resource-preview.unsupported.download')), 1 /* TEXT */)
                  ]),
                  _: 1 /* STABLE */
                }))
              : _createCommentVNode("v-if", true)
          ]),
          _: 1 /* STABLE */
        })
      ]),
      _: 1 /* STABLE */
    })
  ]))
}
}

})